import React from 'react';
import PropTypes from 'prop-types';
import InfiniteScroll from 'react-infinite-scroller';

import Search from '../../../../../components/searchField';
import User from '../../user';


const ExtButton = ({
  t,
  users,
  hasMore,
  loadMore,
  startChat,
  userSearchCallback }) => (
    <div className="boxs strtconv strtconvmgt">
      <div className="srtnewconvrstn">
        <a
          href="#"
          className="conversttnlink"
          onClick={e => e.preventDefault()}
        >
          {t('Start new conversation')}
        </a>
        <div className="onhoverconverstn boxs">
          <Search
            placeholder={t('With...')}
            cssClass="form-control form-controlsearch"
            callbackToSetSearch={userSearchCallback}
          />
          <div className="Chat_Boxouter boxs forscroll2 forscrollmessage">
            <InfiniteScroll
              loadMore={loadMore}
              hasMore={hasMore}
              pageStart={1}
              useWindow={false}
              initialLoad={false}
              loader={<div className="loader-ext" key="loader-ext">{t('Loading')} ...</div>}
            >
              {users.map((user, i) =>
                (<User
                  item={user}
                  classNaming="chatbox boxs"
                  onClick={e => startChat(e, user)}
                  key={user.id}
                />))}
            </InfiniteScroll>
          </div>
        </div>
      </div>
    </div>


);

ExtButton.propTypes = {
  t: PropTypes.func.isRequired,
  users: PropTypes.array.isRequired,
  startChat: PropTypes.func.isRequired,
  userSearchCallback: PropTypes.func.isRequired,
};

export default ExtButton;



// WEBPACK FOOTER //
// ./src/views/modules/messages/startConversation/extButton/ExtButton.jsx